<template>
  <div class="wrapper" :class="{ 'wrapper-disabled': disabled }">
    <div v-if="disabled" class="disabled-overlay" @click.stop></div>
    <v-btn
      class="plus"
      :width="isMobile ? 30 : 40"
      :height="isMobile ? 30 : 40"
      :min-width="isMobile ? 30 : 40"
      @click.stop="changeCounter(packageQuant ?? 1)"
    >
      <v-icon icon="mdi-plus" color="white"></v-icon>
    </v-btn>
    <v-slide-x-reverse-transition
      :leave-absolute="false"
      :hide-on-leave="false"
    >
      <template v-if="counter > 0 || isFocused">
        <div class="quantity-wrapper d-flex flex-row-reverse ga-1">
          <input
            @click.stop=""
            :style="{ width: counter > 99 ? '30px' : '25px' }"
            class="quantity"
            type="number"
            name="name"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @change="updateValue"
            v-model="counter"
          />
          <v-btn
            :width="isMobile ? 30 : 40"
            :height="isMobile ? 30 : 40"
            :min-width="isMobile ? 30 : 40"
            class="minus"
            @click.stop="changeCounter((packageQuant ?? 1) * -1)"
          >
            <v-icon icon="mdi-minus" color="#BD9478"></v-icon>
          </v-btn>
        </div>
      </template>
    </v-slide-x-reverse-transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    TheCounter: {
      type: Number,
    },
    TheTitle: {
      type: String,
    },
    packageQuant: {
      type: Number,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      counter: 0,
      isFocused: false,
    };
  },
  mounted() {
    if (this.TheCounter) this.counter = this.TheCounter;
    else this.counter = 0;
  },
  watch: {
    TheCounter: {
      immediate: false,
      handler() {
        if (this.TheCounter) this.counter = this.TheCounter;
        else this.counter = 0;
      },
    },
  },
  emits: ["updateCounter"],
  computed: {
    ...mapGetters({
      isAuthenticated: "AuthModule/isAuthenticated",
      isUserGuest: "AuthModule/isUserGuest",
      isMobile: "isMobile",
    }),
  },
  methods: {
    ...mapActions({
      setLoginModel: "AuthModule/setLoginModel",
    }),
    updateValue() {
      if (this.packageQuant) {
        this.counter =
          Math.ceil(this.counter / this.packageQuant) * this.packageQuant;
      }
      // if (this.counter == "") return;
      this.$emit("updateCounter", this.counter);
    },
    changeCounter(int) {
      if (!this.isAuthenticated && !this.isUserGuest) {
        this.setLoginModel(true);
        return;
      }
      this.counter += int;
      if (isNaN(this.counter) || this.counter < 0) {
        this.counter = 0;
      }
      this.$emit("updateCounter", this.counter);
    },
  },
};
</script>

<style scoped lang="scss">
.hidden {
  visibility: hidden;
}
.add-wrapper {
  background: #f4f4f4;
  padding: 10px;
}
.wrapper {
  position: relative;
  // background: #f8f8f8;
  width: fit-content;
  padding: 5px 0px;
  align-items: center;
  border-radius: 20px;
  display: flex;
  flex-direction: row-reverse;
  gap: 4px;

  .plus {
    // border-radius: 20px;
    background: $primaryColor;
    font-size: 22px;
    box-shadow: unset;
    color: white;
    font-weight: 700;
  }
  .quantity {
    text-align: center;
    background: #f4f4f4;
    width: 50px !important;
    box-shadow: inset 0 0 10px rgba(1, 1, 1, 0.135);
    // height: 30px !important;
  }
  .minus {
    height: 30px;
    box-shadow: unset !important;
    border: 1px solid $primaryColor;
  }
  label {
    color: #36b079;
  }
}

.wrapper-disabled {
  // opacity: 0.7;
  pointer-events: none;
}

.disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  cursor: not-allowed;
  pointer-events: all;
}

html:has(.isMobile) {
  .quantity {
    height: 30px !important;
  }
}
</style>
